// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section[data-v-4d0c8913]{align-items:center;display:flex;flex-direction:row;justify-content:space-between;margin:.5em 0 0}img[data-v-4d0c8913]{height:1.5em;width:auto}.selected-categories img~img[data-v-4d0c8913]{margin-left:.4em}.selected-categories~.touring-pitches[data-v-4d0c8913]{margin-left:.25em}.disabled[data-v-4d0c8913]{filter:grayscale(1);opacity:.3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
